const CURRENT_YEAR_TOKEN = '$currentyear$'
const CURRENT_YEAR_SELECTOR = '[data-lay-current-year]'
const SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION']

const getCurrentYear = () => String(new Date().getFullYear())

const normalizeRoot = (root) => {
	if (!root) {
		return document.body
	}
	if (root.jquery) {
		return root[0]
	}
	return root
}

const shouldSkipTextNode = (node) => {
	const parent = node && node.parentElement
	if (!parent || SKIP_TAGS.includes(parent.tagName)) {
		return true
	}
	return parent.closest('[data-lay-current-year]') !== null
}

const replaceRawTokens = (root, year) => {
	if (!root) {
		return
	}
	if (root.nodeType === Node.TEXT_NODE) {
		if (!shouldSkipTextNode(root) && root.nodeValue.includes(CURRENT_YEAR_TOKEN)) {
			root.nodeValue = root.nodeValue.split(CURRENT_YEAR_TOKEN).join(year)
		}
		return
	}
	if (!root.querySelectorAll) {
		return
	}
	const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
		acceptNode: (node) => (shouldSkipTextNode(node) || !node.nodeValue.includes(CURRENT_YEAR_TOKEN) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
	})
	const nodes = []
	while (walker.nextNode()) {
		nodes.push(walker.currentNode)
	}
	nodes.forEach((node) => {
		node.nodeValue = node.nodeValue.split(CURRENT_YEAR_TOKEN).join(year)
	})
}

const updateCurrentYear = (root) => {
	const target = normalizeRoot(root)
	if (!target) {
		return
	}
	const year = getCurrentYear()
	if (target.matches && target.matches(CURRENT_YEAR_SELECTOR)) {
		target.textContent = year
	}
	if (target.querySelectorAll) {
		target.querySelectorAll(CURRENT_YEAR_SELECTOR).forEach((el) => {
			el.textContent = year
		})
	}
	replaceRawTokens(target, year)
}

const current_year_controller = {
	i: function () {
		updateCurrentYear(document.body)
		window.laytheme.on('newpageshown', function () {
			updateCurrentYear(document.body)
		})
		window.laytheme.on('content_ready', function (typeOfContentThatIsReady, $target) {
			updateCurrentYear($target)
		})
	},
	update: updateCurrentYear,
}

export default current_year_controller
